/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";

import { Button } from "@mui/material";
import CustomLoader from "../CustomLoader/CustomLoader";
import CustomToast from "../Toast/CustomToast";
import DataTable from "react-data-table-component";
import { ENDPOINT } from "../../services/endPoints";
import FilterDataComponent from "./FilterDataComponent";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import UserDetail from "./UserDetail";
import dayjs from "dayjs";
import { downloadXLSX } from "../../utils/helpers";
import { filterFromData } from "./tableHelper";
import useMasterApi from "../../services/useMasterApi";
import { useMemo } from "react";
import { useState } from "react";
import useToast from "../../hooks/useToast";

const sortIcon = <KeyboardArrowDownIcon />;

const CustomDataTable = ({columns, endPointWithId, rowData, isCustom=false,  tableTitle, endPoint,  excludedKeys, hospitalId, isCommentAdded,
  customKeyName, compareValue, customWidth, conditionalRowStyles }) => {
  const { getWithQueryParams, loading, data: masterData } = useMasterApi();
  const { toastMessage, toast, toastType, setToast, showToast } = useToast()
  const { getWithQueryParams: getFullExcelData, loading: fullDataLoading, data: fullDataCSV } = useMasterApi();
  const [fullDowlodData, setFullDowlodData] = useState();


  const [columnData, setColumnData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  
  const [perPage, setPerPage] = useState(10);

  
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

 
  const filteredItems = filterFromData(isCustom ? rowData:  masterData.values.rows, filterText);

  
  const Export = ({ onExport }) => (
    <Button size="small" onClick={(e) => onExport(e.target.value)}>
      Export XLSX
    </Button>
  );

  useEffect(() => {
    if(!isCustom){
      getWithQueryParams(endPoint, { page: 1, limit: 10 });
      getFullExcelData(`${endPoint}/xls`, { page: 1, limit: 100000 });
    }
  }, []);

  useEffect(()=>{
    if(fullDataCSV){
      setFullDowlodData(fullDataCSV)
    }
  },[fullDataCSV])
  

  useEffect(()=>{
    if(isCommentAdded?.length || isCommentAdded?.data){
      getWithQueryParams(endPoint, { page: 1, limit: perPage });
    }
  },[isCommentAdded])

  const actionsMemo = useMemo(
    () => <Export onExport={() => downloadXLSX(isCustom ? rowData : fullDowlodData)} />,
    [masterData, rowData, fullDowlodData]
  );
  const handlePageChange = (page) => {
    if(!isCustom){
      getWithQueryParams(endPoint, { page: page, limit: perPage });
    }
   
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    if(!isCustom){
    getWithQueryParams(endPoint, { page: page, limit: newPerPage });
    }
    setPerPage(newPerPage);
  };

  useEffect(() => {
    if (Object.keys(masterData).length > 0 && !isCustom) {
      setTotalRows(masterData.total);
      if (masterData.values.rows.length) {
        const keys = Object.keys(masterData.values.rows[0]);
        const newColumnsData = keys.map((key) => 
        !excludedKeys.includes(key) ? {
          name: compareValue?.includes(key) ? customKeyName[key] : key,
          maxWidth: customWidth ? customWidth[key] : undefined,
          selector: (row) => key==="form_type" ? row["form_type"] === "2" ? "Eye Form" : "Foot Form" : 
          key==="createdAt" ? dayjs(row[key]).format("DD-MM-YYYY") : row[key],
        } : null
            ).filter(Boolean)
        if (endPoint === `${ENDPOINT.PATIENT}/${hospitalId}`) {
          newColumnsData.push({
            name: "Details",
            cell: (row)=><UserDetail row={row} endPoint={endPoint}/>
          });
        }
        setColumnData(newColumnsData); 
      }
    }
  }, [masterData.values.rows]);

 const subHeaderComponentMemo = useMemo(() => {
    return (
      <FilterDataComponent
        filterText={filterText}
        setFilterText={setFilterText}
        resetPaginationToggle={resetPaginationToggle}
        setResetPaginationToggle={setResetPaginationToggle}
      />
    );
  }, [filterText, resetPaginationToggle]);

  return (
    <>
      <DataTable
        title={tableTitle}
        columns={isCustom ? columns : columnData}
        data={filteredItems}
        sortIcon={sortIcon}
        highlightOnHover
        progressPending={loading}
        progressComponent=<CustomLoader />
        paginationResetDefaultPage={resetPaginationToggle}
        subHeader
        subHeaderComponent={subHeaderComponentMemo}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 50]}
        paginationPerPage={perPage}
        actions={actionsMemo}
        conditionalRowStyles={conditionalRowStyles ? conditionalRowStyles : undefined}
      />
      {toast && <CustomToast 
        open={toast}
        toastMessage={toastMessage}
        setToast={setToast}
        toastType={toastType}
      />}
    </>
  );
};

export default CustomDataTable;
